import { mutator } from 'satcheljs';
import { loading, stoppedLoading } from '../actions/internalActions';
import { getStore } from '../store/store';

mutator(loading, () => {
    getStore().isLoading = true;
});

mutator(stoppedLoading, () => {
    getStore().isLoading = false;
});
